import { clone } from '../../helpers/';
import types from '../types';

interface IOperationState {
	suppressHashChange: boolean;
}

export const initialState: IOperationState = {
	suppressHashChange: false
};

const operationReducer = function(state:IOperationState = initialState, action): IOperationState {

	let stateClone:IOperationState = clone(state);

	switch(action.type) {
		case types.SET_SUPPRESS_HASH_CHANGE:
			stateClone = suppressHashChange(stateClone, action.suppressHashChange);
			break;
		default:
			break;
	}

	return stateClone;

};

let suppressHashChange = (state: IOperationState, suppressHashChange: boolean): IOperationState => {

	state.suppressHashChange = suppressHashChange;

	return state;

};

export default operationReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/operation.ts